export const api = {
  token: "API-c9bbc0b0bb911c8ca98bccfe7d0fb4040208c0ee",
  url: "https://data.vitamin-d.live/",
  assets: "https://data.vitamin-d.live/storage/uploads",
  download: "https://data.vitamin-d.live/download.php?file=",
  thumb(asset, width = 400) {
    if (!asset || !asset._id) return "";
    return (
      this.url +
      "api/assets/image/" +
      asset._id +
      "?w=" +
      width +
      "&m=fitToHeight&q=86&o=1&api_key=" +
      this.token
    );
  },
};
